(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  if (window.__izhHeader) return;
  window.__izhHeader = true;

  var header = document.querySelector('[data-izh-header]');
  var drawer = document.getElementById('IzhDrawer');
  var search = document.getElementById('IzhSearch');
  if (!header || !drawer || !search) return;

  var burger = header.querySelector('[data-izh-open]');
  var lastFocus = null;

  function setDrawer(open) {
    drawer.classList.toggle('is-open', open);
    drawer.toggleAttribute('inert', !open);
    burger.setAttribute('aria-expanded', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      lastFocus = document.activeElement;
      var first = drawer.querySelector('.izh-drawer__nav a');
      if (first) first.focus();
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }

  function setSearch(open) {
    search.classList.toggle('is-open', open);
    search.toggleAttribute('inert', !open);
    header.querySelectorAll('[data-izh-search-toggle]').forEach(function (b) {
      if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', open);
    });
    if (open) search.querySelector('input[type=search]').focus();
  }

  burger.addEventListener('click', function () { setDrawer(true); });
  drawer.querySelectorAll('[data-izh-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  header.querySelectorAll('[data-izh-search-toggle]').forEach(function (el) {
    el.addEventListener('click', function () { setSearch(!search.classList.contains('is-open')); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer.classList.contains('is-open')) setDrawer(false);
    if (search.classList.contains('is-open')) setSearch(false);
  });

  // Keep Tab inside the open drawer
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = drawer.querySelectorAll('a[href],button');
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  // Condense on scroll
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      // announcement bar: hide after 100px, show again only near the top
      if (y > 100) header.classList.add('is-ann-hidden');
      else if (y < 20) header.classList.remove('is-ann-hidden');
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();
})();
